import routerOptions0 from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.17.7_6448f8ee51aa111c8be57d0bb2ba9ecd/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}